var render = function () {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { key: _vm.activeConversation._id, staticClass: "userInfoWidget" },
    [
      _c("div", { attrs: { id: "chatCard" } }, [
        _c("div", { staticClass: "headtitle" }, [
          _c("span", { staticClass: "text" }, [
            _vm._v(_vm._s(_vm.$t("userInfoWidget.userInformation"))),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "ml-4" }, [
            _c(
              "button",
              {
                staticClass: "classic-button",
                on: {
                  click: function ($event) {
                    _vm.newEventModalVisible = true
                  },
                },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("message.addCalendarEvent")) +
                    "\n                "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "ml-4" }, [
            _c(
              "button",
              {
                staticClass: "classic-button",
                on: {
                  click: function () {
                    return this$1.$router.push(
                      "visitors/" + _vm.activeConversation.visitor._id
                    )
                  },
                },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("message.userProfile")) +
                    "\n                "
                ),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "details-chat-card" },
          [
            _vm.getSubjectName(_vm.activeConversation.subject)
              ? _c("div", { staticClass: "user-detail" }, [
                  _c("span", { staticClass: "icon material-icons" }, [
                    _vm._v("sell"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex w-full centered space-between" },
                    [
                      _c("span", [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.getSubjectName(_vm.activeConversation.subject)
                            ) +
                            "\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "copyButton",
                          on: {
                            click: function ($event) {
                              _vm.copyTextToClipboard(
                                _vm.getSubjectName(
                                  _vm.activeConversation.subject
                                ) || "N/A"
                              )
                            },
                          },
                        },
                        [_c("a-icon", { attrs: { type: "copy" } })],
                        1
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "user-detail" }, [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: {
                        followCursor: true,
                        placement: "bottom-end",
                      },
                      expression:
                        "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                    },
                  ],
                  staticClass: "icon material-icons",
                  attrs: { content: _vm.$t("userInfoWidget.fullName") },
                },
                [_vm._v("person")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "input-value" }, [
                _vm.editVisitorProperty == "visitorUsenameInput"
                  ? _c(
                      "div",
                      { staticClass: "edited-input" },
                      [
                        _c("a-input", {
                          staticClass: "mr-1",
                          on: {
                            mouseleave: function ($event) {
                              _vm.editVisitorProperty = null
                            },
                            change: function ($event) {
                              return _vm.changeVisitorUsername()
                            },
                          },
                          model: {
                            value: _vm.editVisitorPropertyValue,
                            callback: function ($$v) {
                              _vm.editVisitorPropertyValue = $$v
                            },
                            expression: "editVisitorPropertyValue",
                          },
                        }),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      {
                        staticClass: "w-full",
                        on: {
                          mouseover: function ($event) {
                            _vm.editVisitorProperty = "visitorUsenameInput"
                            _vm.editVisitorPropertyValue =
                              _vm.activeConversation.fullname || ""
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.activeConversation.fullname || "N/A") +
                            "\n                    "
                        ),
                      ]
                    ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("ActionEdit", {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                            theme: _vm.isDarkMode ? "light-border" : "google",
                          },
                          expression:
                            "{\n                                followCursor: true,\n                                placement: 'bottom-end',\n                                theme: isDarkMode ? 'light-border' : 'google',\n                            }",
                        },
                      ],
                      staticStyle: { "font-size": "10px !important" },
                      attrs: {
                        content: _vm.$t("userInfoWidget.clickToEdit"),
                        height: "11",
                        width: "11",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "copyButton",
                        on: {
                          click: function ($event) {
                            return _vm.copyTextToClipboard(
                              _vm.activeConversation.fullname || "N/A"
                            )
                          },
                        },
                      },
                      [_c("a-icon", { attrs: { type: "copy" } })],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "user-detail" }, [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: {
                        followCursor: true,
                        placement: "bottom-end",
                      },
                      expression:
                        "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                    },
                  ],
                  staticClass: "icon material-icons",
                  attrs: { content: _vm.$t("coupon.email") },
                },
                [_vm._v("mail")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "input-value" }, [
                _vm.editVisitorProperty == "visitorEmailInput"
                  ? _c(
                      "div",
                      { staticClass: "edited-input" },
                      [
                        _c("a-input", {
                          staticClass: "mr-1",
                          on: {
                            mouseleave: function ($event) {
                              _vm.editVisitorProperty = null
                            },
                            change: function ($event) {
                              return _vm.changeVisitorEmail()
                            },
                          },
                          model: {
                            value: _vm.editVisitorPropertyValue,
                            callback: function ($$v) {
                              _vm.editVisitorPropertyValue = $$v
                            },
                            expression: "editVisitorPropertyValue",
                          },
                        }),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      {
                        staticClass: "w-full",
                        on: {
                          mouseover: function ($event) {
                            _vm.editVisitorProperty = "visitorEmailInput"
                            _vm.editVisitorPropertyValue =
                              _vm.activeConversation.email || ""
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.activeConversation.email === ""
                                ? "N/A"
                                : _vm.activeConversation.email
                            ) +
                            "\n                    "
                        ),
                      ]
                    ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("ActionEdit", {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                            theme: _vm.isDarkMode ? "light-border" : "google",
                          },
                          expression:
                            "{\n                                followCursor: true,\n                                placement: 'bottom-end',\n                                theme: isDarkMode ? 'light-border' : 'google',\n                            }",
                        },
                      ],
                      staticStyle: { "font-size": "10px !important" },
                      attrs: {
                        content: _vm.$t("userInfoWidget.clickToEdit"),
                        height: "11",
                        width: "11",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "copyButton",
                        on: {
                          click: function ($event) {
                            return _vm.copyTextToClipboard(
                              _vm.activeConversation.email || "N/A"
                            )
                          },
                        },
                      },
                      [_c("a-icon", { attrs: { type: "copy" } })],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "user-detail" },
              [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "bottom-end",
                        },
                        expression:
                          "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                      },
                    ],
                    staticClass: "icon material-icons",
                    attrs: { content: _vm.$t("message.language") },
                  },
                  [_vm._v("language")]
                ),
                _vm._v(" "),
                _vm.selectedLang
                  ? _c(
                      "div",
                      { staticClass: "flex centered space-between w-full" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "lang-info input-value",
                            on: {
                              click: function ($event) {
                                _vm.isVisibleLangModal = true
                              },
                            },
                          },
                          [
                            _c("div", [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.selectedLang.originalName) +
                                  "\n                        "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("ActionEdit", {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    followCursor: true,
                                    placement: "bottom-end",
                                    theme: _vm.isDarkMode
                                      ? "light-border"
                                      : "google",
                                  },
                                  expression:
                                    "{\n                                followCursor: true,\n                                placement: 'bottom-end',\n                                theme: isDarkMode ? 'light-border' : 'google',\n                            }",
                                },
                              ],
                              staticStyle: { "font-size": "10px !important" },
                              attrs: {
                                content: _vm.$t("userInfoWidget.clickToEdit"),
                                height: "11",
                                width: "11",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "copyButton",
                            on: {
                              click: function ($event) {
                                return _vm.copyTextToClipboard(
                                  _vm.selectedLang.originalName || "N/A"
                                )
                              },
                            },
                          },
                          [_c("a-icon", { attrs: { type: "copy" } })],
                          1
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isVisibleLangModal
                  ? _c(
                      "Modal2",
                      {
                        attrs: {
                          title: _vm.$t("message.languageSelection"),
                          "show-footer": false,
                        },
                        on: {
                          cancel: function ($event) {
                            _vm.isVisibleLangModal = false
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c(
                              "a-select",
                              {
                                staticClass: "my-2",
                                attrs: {
                                  "show-search": "",
                                  "option-filter-prop": "children",
                                  "filter-option": _vm.filterOption,
                                  autofocus: true,
                                },
                                model: {
                                  value:
                                    _vm.activeConversation.visitor
                                      .preferredLang,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.activeConversation.visitor,
                                      "preferredLang",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "activeConversation.visitor.preferredLang",
                                },
                              },
                              _vm._l(_vm.languages, function (lang) {
                                return _c(
                                  "a-select-option",
                                  {
                                    key: lang.code,
                                    attrs: { value: lang.code },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(lang.originalName) +
                                        "\n                            "
                                    ),
                                  ]
                                )
                              }),
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                attrs: { size: "sm", variant: "success" },
                                on: { click: _vm.updateVisitorLang },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.$t("message.save")) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _vm._l(_vm.getCustomLoginInfos(), function (inputValue, index) {
              return Array.isArray(_vm.activeConversation.customLoginInfos) &&
                _vm.activeConversation.customLoginInfos.length
                ? _c(
                    "div",
                    { key: inputValue.id, staticClass: "user-detail" },
                    [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                followCursor: true,
                                placement: "bottom-end",
                              },
                              expression:
                                "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                            },
                          ],
                          staticClass: "icon material-icons",
                          attrs: { content: inputValue.name },
                        },
                        [_vm._v("alternate_email")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-value" }, [
                        _vm.editVisitorProperty == inputValue.id
                          ? _c(
                              "div",
                              {
                                ref: "" + inputValue.id,
                                refInFor: true,
                                staticClass: "edited-input",
                              },
                              [
                                _c("a-input", {
                                  staticClass: "mr-1",
                                  on: {
                                    mouseleave: function ($event) {
                                      _vm.editVisitorProperty = null
                                    },
                                    change: function ($event) {
                                      return _vm.changeCustomLogin()
                                    },
                                  },
                                  model: {
                                    value: _vm.editVisitorPropertyValue,
                                    callback: function ($$v) {
                                      _vm.editVisitorPropertyValue = $$v
                                    },
                                    expression: "editVisitorPropertyValue",
                                  },
                                }),
                              ],
                              1
                            )
                          : _c(
                              "div",
                              {
                                staticClass: "w-full",
                                on: {
                                  mouseover: function ($event) {
                                    _vm.editVisitorProperty = inputValue.id
                                    _vm.editVisitorPropertyValue =
                                      inputValue.value || ""
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(inputValue.value || "N/A") +
                                    "\n                    "
                                ),
                              ]
                            ),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c("ActionEdit", {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    followCursor: true,
                                    placement: "bottom-end",
                                    theme: _vm.isDarkMode
                                      ? "light-border"
                                      : "google",
                                  },
                                  expression:
                                    "{\n                                followCursor: true,\n                                placement: 'bottom-end',\n                                theme: isDarkMode ? 'light-border' : 'google',\n                            }",
                                },
                              ],
                              staticStyle: { "font-size": "10px !important" },
                              attrs: {
                                content: _vm.$t("userInfoWidget.clickToEdit"),
                                height: "11",
                                width: "11",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "copyButton",
                                on: {
                                  click: function ($event) {
                                    return _vm.copyTextToClipboard(
                                      inputValue.value || "N/A"
                                    )
                                  },
                                },
                              },
                              [_c("a-icon", { attrs: { type: "copy" } })],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  )
                : _vm._e()
            }),
            _vm._v(" "),
            _vm._l(
              ((_vm.visitor && _vm.visitor.contactProperties) || []).filter(
                function (x) {
                  return x.property
                }
              ),
              function (attr) {
                return _vm.visitor
                  ? _c("div", { key: attr._id, staticClass: "user-detail" }, [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                followCursor: true,
                                placement: "bottom-end",
                              },
                              expression:
                                "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                            },
                          ],
                          staticClass: "icon material-icons",
                          attrs: { content: attr.property.label },
                        },
                        [_vm._v("data_object")]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-weight": "bold",
                            "font-size": "14px",
                            width: "100px",
                          },
                          attrs: { content: attr.property.label },
                        },
                        [_vm._v(_vm._s(attr.property.label) + ":")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-value" }, [
                        _vm.editVisitorProperty == attr.property._id
                          ? _c(
                              "div",
                              { staticClass: "edited-input" },
                              [
                                _c("a-input", {
                                  staticClass: "mr-1",
                                  on: {
                                    mouseleave: function ($event) {
                                      _vm.editVisitorProperty = null
                                    },
                                    change: function ($event) {
                                      return _vm.changeVisitorAttr()
                                    },
                                  },
                                  model: {
                                    value: _vm.editVisitorPropertyValue,
                                    callback: function ($$v) {
                                      _vm.editVisitorPropertyValue = $$v
                                    },
                                    expression: "editVisitorPropertyValue",
                                  },
                                }),
                              ],
                              1
                            )
                          : _c(
                              "div",
                              {
                                staticClass: "w-full",
                                on: {
                                  mouseover: function ($event) {
                                    _vm.editVisitorProperty = attr.property._id
                                    _vm.editVisitorPropertyValue = attr.value
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(attr.value || "N/A") +
                                    "\n                    "
                                ),
                              ]
                            ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex centered" }, [
                        _c(
                          "button",
                          {
                            staticClass: "removeButton",
                            on: {
                              click: function ($event) {
                                return _vm.removeVisitorAttr(attr._id)
                              },
                            },
                          },
                          [_c("a-icon", { attrs: { type: "delete" } })],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "copyButton",
                            on: {
                              click: function ($event) {
                                return _vm.copyTextToClipboard(
                                  attr.value || "N/A"
                                )
                              },
                            },
                          },
                          [_c("a-icon", { attrs: { type: "copy" } })],
                          1
                        ),
                      ]),
                    ])
                  : _vm._e()
              }
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "user-detail" },
              [
                _c("span", { staticClass: "material-icons icon" }, [
                  _vm._v("add"),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "classic-button visitor-attr",
                    on: {
                      click: function ($event) {
                        _vm.addNewAttribue = true
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("userInfoWidget.newValue")) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.addNewAttribue
                  ? _c(
                      "Modal2",
                      {
                        attrs: {
                          title: _vm.$t("userInfoWidget.newProfileInfo"),
                          "show-footer": false,
                        },
                        on: {
                          cancel: function ($event) {
                            _vm.addNewAttribue = false
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c(
                              "h6",
                              {
                                staticStyle: {
                                  "font-size": "14px",
                                  color: "#000 !important",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.$t("userInfoWidget.newProfileInfo")
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", [_vm._v("Contact Property")]),
                            _vm._v(" "),
                            _c(
                              "a-select",
                              {
                                staticClass: "my-2",
                                attrs: {
                                  "show-search": "",
                                  "option-filter-prop": "children",
                                  "filter-option": _vm.filterOption,
                                  autofocus: true,
                                },
                                model: {
                                  value: _vm.newAttributeForm.key,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newAttributeForm, "key", $$v)
                                  },
                                  expression: "newAttributeForm.key",
                                },
                              },
                              [
                                _vm._l(
                                  _vm.visitorAttributes,
                                  function (attr, index) {
                                    return _c(
                                      "a-select-option",
                                      {
                                        key: index,
                                        attrs: { value: attr._id },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(attr.label) +
                                            "\n                            "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-select-option",
                                  { key: "new", attrs: { value: "new" } },
                                  [_vm._v(" New Property")]
                                ),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _vm.newAttributeForm.key == "new"
                              ? _c("div", [_vm._v("Label")])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.newAttributeForm.key == "new"
                              ? _c("a-input", {
                                  staticClass: "mb-2",
                                  model: {
                                    value: _vm.newAttributeForm.newKey,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.newAttributeForm,
                                        "newKey",
                                        $$v
                                      )
                                    },
                                    expression: "newAttributeForm.newKey",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.newAttributeForm.key
                              ? _c("div", [_vm._v("Value")])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.newAttributeForm.key
                              ? _c("a-input", {
                                  model: {
                                    value: _vm.newAttributeForm.value,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.newAttributeForm,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "newAttributeForm.value",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "justify-content": "end",
                                },
                              },
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "classic-button mt-2",
                                    attrs: { size: "sm", variant: "success" },
                                    on: { click: _vm.createVisitorAttribute },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.$t("message.save")) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _vm.$_.get(_vm.visitor, "metaReferrals", []).length > 0
        ? _c("VisitorMetaReferralsCard", {
            attrs: { metaReferrals: _vm.visitor.metaReferrals },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("VisitorCalendarCard", {
        attrs: { visitorId: _vm.activeConversation.visitor._id },
      }),
      _vm._v(" "),
      _c("div", { attrs: { id: "chatCard" } }, [
        _c(
          "div",
          { staticClass: "headtitle" },
          [
            _c("span", { staticClass: "text" }, [
              _vm._v(
                _vm._s(_vm.$t("userInfoWidget.affiliatedRepresentatives")) + " "
              ),
            ]),
            _vm._v(" "),
            !_vm.observing.includes(_vm.activeConversation._id)
              ? _c(
                  "div",
                  { staticClass: "d-flex flex-row" },
                  [
                    _c(
                      "a-button",
                      {
                        staticClass:
                          "justify-content-around pl-3 popoverFont cursorPointer",
                        attrs: { ghost: "", id: "forwardButton" },
                        on: { click: _vm.openDelegateAssignment },
                      },
                      [
                        _c("font-awesome-icon", {
                          staticStyle: { "margin-right": "5px" },
                          attrs: { icon: "share" },
                        }),
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("message.forwardRep")) +
                            "\n                "
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.modalDelegateAssignment
              ? _c(
                  "Modal2",
                  {
                    attrs: {
                      id: "Modal2",
                      title: _vm.$t("message.forwardRepresentative"),
                      "show-footer": false,
                      "class-name": "forwardRepresentativeModal",
                    },
                    on: {
                      cancel: function ($event) {
                        _vm.modalDelegateAssignment = false
                      },
                    },
                  },
                  [
                    _c("AgentList", {
                      attrs: { forward: true, "show-online-agents": true },
                      on: {
                        closeModal: function ($event) {
                          _vm.modalDelegateAssignment = false
                        },
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.observing.includes(_vm.activeConversation._id)
              ? _c(
                  "a-button",
                  {
                    staticClass:
                      "justify-content-around pl-3 popoverFont cursorPointer",
                    attrs: { ghost: "", id: "joinButton" },
                    on: {
                      click: function ($event) {
                        return _vm.joinTheChat(_vm.activeConversation)
                      },
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("message.joinChat")) + "\n            "
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { display: "flex", "align-items": "center" } },
          _vm._l(_vm.getAgentNames(_vm.activeConversation), function (user) {
            return _c(
              "a-tag",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: { followCursor: true, placement: "bottom-start" },
                    expression:
                      "{ followCursor: true, placement: 'bottom-start' }",
                  },
                ],
                key: user,
                staticClass: "user-detail-name",
                attrs: { color: "orange", content: user },
              },
              [
                _vm._v(
                  "\n                " + _vm._s(user || "") + "\n            "
                ),
              ]
            )
          }),
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { id: "chatCard" } },
        [
          _c("div", { staticClass: "headtitle" }, [
            _c("span", { staticClass: "text" }, [
              _vm._v(_vm._s(_vm.$t("userInfoWidget.preferredAgents"))),
            ]),
          ]),
          _vm._v(" "),
          _vm.visitor
            ? _c("PreferredAgents", {
                attrs: { visitorId: _vm.visitor._id },
                model: {
                  value: _vm.visitor.preferredAgents,
                  callback: function ($$v) {
                    _vm.$set(_vm.visitor, "preferredAgents", $$v)
                  },
                  expression: "visitor.preferredAgents",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { attrs: { id: "chatCard" } }, [
        _c("div", { staticClass: "headtitle" }, [
          _c("span", { staticClass: "text" }, [
            _vm._v(_vm._s(_vm.$t("userInfoWidget.labels"))),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "span",
          [
            _c("TagDialog", {
              attrs: { "hide-add": false },
              model: {
                value: _vm.tags,
                callback: function ($$v) {
                  _vm.tags = $$v
                },
                expression: "tags",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { attrs: { id: "chatCard" } }, [
        _c("div", { staticClass: "headtitle" }, [
          _c("span", { staticClass: "text" }, [
            _vm._v(_vm._s(_vm.$t("userInfoWidget.agentNotes"))),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "ml-4" }, [
            !_vm.isNewNot
              ? _c(
                  "button",
                  {
                    staticClass: "classic-button",
                    on: {
                      click: function ($event) {
                        _vm.isNewNot = true
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("userInfoWidget.newNote")) +
                        "\n                "
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _vm.isNewNot
          ? _c(
              "div",
              { staticClass: "rep-note-element mt-2" },
              [
                _c("a-textarea", {
                  staticClass: "disableShortcut",
                  model: {
                    value: _vm.info,
                    callback: function ($$v) {
                      _vm.info = $$v
                    },
                    expression: "info",
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "rep-note-actions mt-1" },
                  [
                    _c(
                      "a-button-group",
                      { attrs: { size: "small" } },
                      [
                        _c("a-button", {
                          staticClass: "classic-button mr-1",
                          attrs: { icon: "close", type: "danger" },
                          on: { click: _vm.notSaveInfo },
                        }),
                        _vm._v(" "),
                        _c("a-button", {
                          staticClass: "classic-button",
                          staticStyle: { color: "rgb(38, 233, 38)" },
                          attrs: { icon: "check", type: "primary" },
                          on: { click: _vm.saveInfo },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.lastNote
          ? _c(
              "div",
              {
                staticClass: "old-note",
                on: {
                  click: function ($event) {
                    _vm.oldNoteIsOpen = !_vm.oldNoteIsOpen
                  },
                },
              },
              [
                _c("button", { staticClass: "classic-button open-note" }, [
                  _c("span", { staticClass: "material-icons icon" }, [
                    _vm._v(_vm._s(_vm.oldNoteIsOpen ? "remove" : "add")),
                  ]),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "information" }, [
                  _c("b", [_vm._v("1")]),
                  _vm._v(" " + _vm._s(_vm.$t("userInfoWidget.available"))),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.oldNoteIsOpen && _vm.lastNote
          ? _c("div", { staticClass: "old-note-desc" }, [
              _c("div", { staticClass: "top-header" }, [
                _c("div", { staticClass: "agent-name" }, [
                  _vm._v(_vm._s(_vm.lastNote.representativeName)),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "bottom-end",
                        },
                        expression:
                          "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                      },
                    ],
                    staticClass: "old-note-date",
                    attrs: {
                      content: _vm
                        .$moment(_vm.lastNote.createdAt)
                        .format("LLL"),
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.lastNote.createdAt &&
                            _vm.$moment(_vm.lastNote.createdAt).fromNow()
                        ) +
                        "\n                "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "agent-note" }, [
                _vm._v(_vm._s(_vm.lastNote.representativeNote)),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { attrs: { id: "chatCard" } }, [
        _c("div", { staticClass: "headtitle" }, [
          _c("span", { staticClass: "text" }, [
            _vm._v(_vm._s(_vm.$t("userInfoWidget.systemInformation"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "details-chat-card" }, [
          _c("div", { staticClass: "user-detail" }, [
            _c(
              "span",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: {
                      followCursor: true,
                      placement: "bottom-end",
                    },
                    expression:
                      "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                  },
                ],
                staticClass: "icon material-icons",
                attrs: { content: _vm.$t("userInfoWidget.speechID") },
              },
              [_vm._v("badge")]
            ),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.activeConversation._id))]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "user-detail" }, [
            _c(
              "span",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: {
                      followCursor: true,
                      placement: "bottom-end",
                    },
                    expression:
                      "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                  },
                ],
                staticClass: "icon material-icons",
                attrs: { content: _vm.$t("userInfoWidget.customerVersion") },
              },
              [_vm._v("info")]
            ),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    (
                      this.activeConversation.visitor.version || {
                        version: -1,
                        versionStr: "N/A",
                        buildNumber: -1,
                        commitHash: "",
                      }
                    ).versionStr
                  ) +
                  "\n                "
              ),
            ]),
          ]),
          _vm._v(" "),
          !_vm.isSocialMediaChat()
            ? _c("div", { staticClass: "user-detail" }, [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: { followCursor: true, placement: "bottom-end" },
                        expression:
                          "{ followCursor: true, placement: 'bottom-end' }",
                      },
                    ],
                    staticClass: "icon material-icons",
                    attrs: { content: _vm.$t("userInfoWidget.IPAddress") },
                  },
                  [_vm._v("computer")]
                ),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.activeConversation.ipAddress) +
                      "\n                "
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.getChannelName()
            ? _c(
                "div",
                { staticClass: "user-detail" },
                [
                  _vm.getChannelType() === "whatsapp-v1"
                    ? _c("WhatsappV1", {
                        staticClass: "whatsapp-channel-info",
                        attrs: { color: "#179d0d" },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getChannelType() === "whatsapp-v2"
                    ? _c("WhatsappV2", {
                        staticClass: "whatsapp-channel-info",
                        attrs: { color: "#179d0d" },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getChannelType() === "whatsapp-business-api"
                    ? _c("WhatsappBusinessIcon", {
                        staticClass: "whatsapp-channel-info",
                        attrs: { color: "#179d0d" },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.getChannelName()) +
                        "\n                "
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.getChannelName()
            ? _c(
                "div",
                { staticClass: "user-detail" },
                [
                  _c("PhoneIcon", { staticClass: "whatsapp-channel-info" }),
                  _vm._v(" "),
                  _c("span", { attrs: { id: "user-phone-number" } }, [
                    _c(
                      "a",
                      { attrs: { href: "tel:" + _vm.getChannelNumber() } },
                      [_vm._v(_vm._s(_vm.getChannelNumber()))]
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "user-detail" }, [
            _c(
              "span",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: {
                      followCursor: true,
                      placement: "bottom-end",
                    },
                    expression:
                      "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                  },
                ],
                staticClass: "icon material-icons",
                attrs: { content: _vm.$t("userInfoWidget.pageVisited") },
              },
              [_vm._v("public")]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticStyle: {
                  "white-space": "nowrap",
                  overflow: "hidden",
                  "text-overflow": "ellipsis",
                },
              },
              [
                _vm.activeConversation.visitingPage
                  ? _c(
                      "a",
                      {
                        staticClass: "info-label",
                        attrs: {
                          href: _vm.activeConversation.visitingPage
                            ? _vm.activeConversation.visitingPage
                            : "#",
                          target: "_blank",
                        },
                      },
                      [_vm._v(_vm._s(_vm.activeConversation.visitingPage))]
                    )
                  : _c("span", [_vm._v("N/A")]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "user-detail" }, [
            _c(
              "span",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: {
                      followCursor: true,
                      placement: "bottom-end",
                    },
                    expression:
                      "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                  },
                ],
                staticClass: "icon material-icons",
                attrs: { content: _vm.$t("userInfoWidget.systemAndBrowser") },
              },
              [_vm._v("settings_suggest")]
            ),
            _vm._v(" "),
            !_vm.isSocialMediaChat()
              ? _c("span", [
                  _vm.activeConversation.visitor.os &&
                  _vm.activeConversation.visitor.browser
                    ? _c("span", [
                        _vm._v(
                          _vm._s(_vm.activeConversation.visitor.os) +
                            " / " +
                            _vm._s(_vm.activeConversation.visitor.browser)
                        ),
                      ])
                    : _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getUserDetailedLoginInfo(
                                _vm.activeConversation.userAgent
                              )
                            )
                        ),
                      ]),
                ])
              : _c("span", [
                  _vm._v(
                    _vm._s(
                      (
                        this.activeConversation.visitor.version || {
                          version: -1,
                          versionStr: "N/A",
                          buildNumber: -1,
                          commitHash: "",
                        }
                      ).versionStr
                    )
                  ),
                ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "user-detail" }, [
            _c(
              "span",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: {
                      followCursor: true,
                      placement: "bottom-end",
                    },
                    expression:
                      "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                  },
                ],
                staticClass: "icon material-icons",
                attrs: { content: _vm.$t("userInfoWidget.countryAndLanguage") },
              },
              [_vm._v("map")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "d-flex",
                staticStyle: { "align-items": "center" },
              },
              [
                _vm.getCountryCode(
                  _vm.$_.get(_vm.activeConversation, "geoLocation.country") ||
                    _vm.activeConversation.languageCode
                )
                  ? _c("country-flag", {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                            theme: _vm.isDarkMode ? "light-border" : "google",
                          },
                          expression:
                            "{\n                            followCursor: true,\n                            placement: 'bottom-end',\n                            theme: isDarkMode ? 'light-border' : 'google',\n                        }",
                        },
                      ],
                      staticStyle: { "margin-top": "-8px" },
                      attrs: {
                        content: _vm.getCountryName(
                          _vm.$_.get(
                            _vm.activeConversation,
                            "geoLocation.country"
                          ) || _vm.activeConversation.languageCode
                        ),
                        country: _vm.getCountryCode(
                          _vm.$_.get(
                            _vm.activeConversation,
                            "geoLocation.country"
                          ) || _vm.activeConversation.languageCode
                        ),
                        size: "normal",
                      },
                    })
                  : _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              followCursor: true,
                              placement: "bottom-end",
                              theme: _vm.isDarkMode ? "light-border" : "google",
                            },
                            expression:
                              "{\n                            followCursor: true,\n                            placement: 'bottom-end',\n                            theme: isDarkMode ? 'light-border' : 'google',\n                        }",
                          },
                        ],
                        attrs: {
                          content: _vm.getCountryName(
                            _vm.$_.get(
                              _vm.activeConversation,
                              "geoLocation.country"
                            ) || _vm.activeConversation.languageCode
                          ),
                        },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.activeConversation.geoLocation
                                ? _vm.activeConversation.geoLocation.country
                                : "N/A"
                            ) +
                            "\n                    "
                        ),
                      ]
                    ),
                _vm._v(" "),
                _c("span", { staticStyle: { "margin-left": "5px" } }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(
                        _vm.activeConversation.languageCode.toUpperCase()
                      ) +
                      "\n                    "
                  ),
                ]),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.newEventModalVisible
        ? _c("CreateEventModal", {
            attrs: {
              calendarList: _vm.calendarList,
              refVisitor: _vm.activeConversation.visitor._id,
            },
            on: {
              close: function ($event) {
                _vm.newEventModalVisible = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }